import { Tooltip, Tag, Table, Alert, DatePicker } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Searchbar from "../components/Searchbar";
import { useListTicketsQuery } from "../graphql/generated/hooks";
import { Margin } from "../components/Spacing";

type Props = {};

export const ListTickets: React.FC<Props> = (props: Props) => {
  const { data: tickets, loading, error } = useListTicketsQuery();
  const columns: any = [
    {
      title: "Ticket ID",
      dataIndex: "name",
      key: "name",
      width: 150,
      fixed: "left",
      render: (text) => <a href={`ticket?name=${text}`}>{text}</a>,
      sorter: (a, b) => {
        return (
          a.name.slice(a.name.indexOf("/") + 1) -
          b.name.slice(b.name.indexOf("/") + 1)
        );
      },
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      ellipsis: true,
      render: (subject) => (
        <Tooltip placement="topLeft" title={subject}>
          {subject}
        </Tooltip>
      ),
    },

    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      responsive: ["md"],
    },
    {
      title: "Created By",
      dataIndex: "createdby",
      key: "createdby",
      responsive: ["md"],
      filters: tickets?.ticketList
        .map((ticket) => ({ text: ticket.username, value: ticket.username }))
        .filter(
          (username, index) =>
            tickets.ticketList
              .map((ticket) => ticket.username)
              .indexOf(username.text) === index
        ),
      onFilter: (value: string, ticket) => ticket.createdby === value,
      filterSearch: true,
    },
    {
      title: "Date Created",
      dataIndex: "date_created",
      key: "date_created",
      responsive: ["md"],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 180,
      fixed: "right",
      filters: tickets?.ticketList
        .map((ticket) => ({
          text: ticket.status,
          value: ticket.status,
        }))
        .filter(
          (status, index) =>
            tickets.ticketList
              .map((ticket) => ticket.status)
              .indexOf(status.text) === index
        ),
      onFilter: (value, ticket) => ticket.status === value,
      render: (tag) => (
        <Tag
          color={
            tag === "New" ? "green" : tag === "Closed" ? "geekblue" : "yellow"
          }
          key={tag}
        >
          {tag}
        </Tag>
      ),
    },
  ];

  const ticketDetails = tickets?.ticketList
    .map((ticket, index) => {
      return {
        key: index,
        name: ticket.name,
        subject: ticket.subject,
        category: ticket.category,
        createdby: ticket.username,
        date_created: moment(new Date(ticket.createdAt).getTime()).format(
          "DD/MM/YYYY - hh:mm A"
        ),
        status: ticket.status,
      };
    })
    .reverse();

  const [ticketData, setTicketData] = useState(ticketDetails);
  const [searchValue, setSearchValue] = useState('');
  const onSearch = (e) => {
    setTicketData(
      ticketDetails?.filter(
        (ticket) =>
          ticket.name.toUpperCase().includes(e.target.value.toUpperCase()) ||
          ticket.subject?.toUpperCase().includes(e.target.value.toUpperCase())
      )
    );
    setSearchValue(e.target.value);
  };

  const { RangePicker } = DatePicker;
  const filterByDateCreated = (startDate, endDate) => {
    startDate && endDate ?
      setTicketData(
        ticketData?.filter(
          (ticket) =>
            moment(ticket.date_created.split(' - ')[0], 'DD/MM/YYYY') >=
              moment(startDate) &&
            moment(ticket.date_created.split(' - ')[0], 'DD/MM/YYYY') <=
              moment(endDate)
        )
      ) 
      : setTicketData(
        ticketDetails?.filter(
          (ticket) =>
            ticket.name.toUpperCase().includes(searchValue.toUpperCase()) ||
            ticket.subject?.toUpperCase().includes(searchValue.toUpperCase())
        )
      );
  };

  useEffect(() => {
    setTicketData(ticketDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tickets]);

  return (
    <>
      {!error && !loading && tickets && (
        <>
          <div style={{ display: 'flex', width: '100%' }}>
            <Searchbar onChange={onSearch} />
            <Margin right={20} />
            <RangePicker
              style={{ height: '35px' }}
              onChange={(date) => {
                filterByDateCreated(date?.[0], date?.[1]);
              }}
            />
          </div>
          <Table
            bordered
            loading={loading && !error}
            columns={columns}
            dataSource={ticketData}
            pagination={{ position: ["bottomCenter"], pageSize: 14 }}
            sticky={true}
          />
        </>
      )}
      {!loading && error && (
        <Alert
          style={{ position: "relative" }}
          closable
          message={error.message}
          type="error"
        ></Alert>
      )}
    </>
  );
};
